export const modulesLegend = ["section", "module", "feature", "task"];
